import React from 'react'

import { UserType } from '@/services/model/user';
import { BodyParams, FieldProps, FormDataBase, FormWrapper, onSubmit } from '@/components/forms/common/FormBase';
import { SubmitHandler } from 'react-hook-form';
import { codeTextField, datePickerField, imeiField, numberField, numericField, textField } from '@/components/forms/common/fields';
import { role, username } from '@/components/forms/users/User';

export interface User {
  id?: string
  imei?: string
  serialNumber?: string
  userTypeId?: string
  internalNumber?: string
  nextUdtInspectionDate?: string
  udtExpirationDate?: string
  inspectionExpirationDate?: string
  userType?: UserType
}

export interface FormData extends User, FormDataBase { }

export interface FormParams extends BodyParams<FormData> {
  onSubmit: onSubmit<FormData>
}

export const QuickCreateUserBody = (params: BodyParams<FormData>) => {
  const fieldProps: FieldProps<FormData> = {
    ...params,
    fieldName: ''
  }
  return <>
    {username(fieldProps)}
    {role(fieldProps)}
  </>
}

export const QuickCreateUserForm = (params: FormParams) => {
  const formHandler: SubmitHandler<FormData> = (data) => {
    params.onSubmit(data);
  }
  return <FormWrapper<FormData> className='main-form main-form-two-col' {...params} formName='user' onSubmit={formHandler} hideSubmitBtn={true}>
    <QuickCreateUserBody {...params} />
  </FormWrapper>
}
